module.exports = __webpack_public_path__ + "static/media/IMG_6417-min.a85070b4.jpg";